const platforms = [
  {
    name: "Windows",
    desc: "Windows 10 / 11",
    version: "V9.8.2",
    size: "118 MB",
    icon: "ri-windows-fill",
    accent: "bg-primary-500",
  },
  {
    name: "macOS",
    desc: "macOS 12 及以上",
    version: "V9.8.0",
    size: "96 MB",
    icon: "ri-mac-fill",
    accent: "bg-accent-500",
  },
  {
    name: "Android",
    desc: "Android 8.0 及以上",
    version: "V9.8.2",
    size: "86 MB",
    icon: "ri-android-fill",
    accent: "bg-secondary-500",
  },
  {
    name: "iOS",
    desc: "iOS 13 及以上",
    version: "V9.7.9",
    size: "132 MB",
    icon: "ri-apple-fill",
    accent: "bg-primary-500",
  },
];

export default function Download() {
  return (
    <section id="download" className="relative bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-primary-400">
            <i className="ri-download-cloud-2-line" aria-hidden="true"></i>
            客户端下载
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">多平台客户端，畅快触达</h2>
          <p className="mx-auto mt-4 max-w-2xl text-foreground-300">
            选择你的设备，下载最新版歪歪客户端。全平台账号数据互通，进度与好友随时同步。
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-xl border border-accent-400/40 bg-accent-500/10 px-5 py-4 flex flex-col sm:flex-row items-center justify-center gap-3 text-center">
          <i className="ri-verified-badge-fill text-2xl text-accent-400" aria-hidden="true"></i>
          <p className="text-sm text-foreground-100">
            最新版本 <strong className="font-semibold text-accent-300">V9.8.2</strong> 已发布 —— 全面优化语音清晰度、启动速度与房间稳定性，建议及时更新。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {platforms.map((item) => (
            <article
              key={item.name}
              className="group flex flex-col rounded-xl border border-background-200/70 bg-background-100 p-6 transition-colors hover:border-primary-400/50"
            >
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${item.accent} text-background-950`}>
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-xl text-foreground-50">{item.name}</h3>
              <p className="mt-1 text-sm text-foreground-400">{item.desc}</p>
              <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
                <span className="rounded-full border border-background-300/70 px-2 py-0.5">{item.version}</span>
                <span>{item.size}</span>
              </div>
              <a
                href="#download"
                className="mt-5 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-950 hover:bg-primary-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-download-2-line" aria-hidden="true"></i>
                立即下载
              </a>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 rounded-xl border border-background-200/70 bg-background-100 px-6 py-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-300 text-foreground-100">
              <i className="ri-global-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base text-foreground-50">网页版 · 无需安装</h3>
              <p className="text-sm text-foreground-400">打开浏览器即可进入频道，轻量便捷，随时随地在线。</p>
            </div>
          </div>
          <a
            href="#download"
            className="inline-flex items-center gap-2 rounded-md border border-primary-400/60 px-5 py-2.5 text-sm font-medium text-primary-300 hover:bg-primary-500/15 transition-colors whitespace-nowrap"
          >
            前往网页版
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}